import { BRAND_PERSON_NAME } from "@/lib/brandConfig";
/**
 * Nombre corto de marca a partir del título de site settings (admin).
 * Formato esperado: "Nombre | Subtítulo" → solo "Nombre".
 */
export function brandDisplayNameFromSiteTitle(
  title: string | undefined,
  fallback = BRAND_PERSON_NAME,
): string {
  const t = title?.trim() ?? "";
  if (!t) return fallback;
  const pipe = t.indexOf("|");
  const head = (pipe >= 0 ? t.slice(0, pipe) : t).trim();
  return head || fallback;
}
